'use strict';
var listen = require('event-listener');
var constants = require('./constants');
var getDomain = require('./util/domain');

var trk = function () {

};

function _nao() {
    // get high-res time, fallback to classic datetime
    var perfNow = window.performance && window.performance.now && window.performance.now();
    var now = parseInt(perfNow || new Date().getTime(), 10);
    return now;
}

/**
 * Creates an invisible iframe (used for beacons, bridges, prefetch loaders) given a name and URL
 *
 * @returns {HTMLIFrameElement}
 */
function _setupIframe(name, url) {
    var iframe;

    // workaround: IE6 + 7 won't let you name an iframe after you create it
    try {
        iframe = document.createElement('<iframe name="' + name + '">');
    } catch (err) {
        iframe = document.createElement('iframe');
        iframe.name = name;
    }

    // batch write attributes as quick as possible
    iframe.setAttribute('style', 'margin: 0; padding: 0; border: 0px none; overflow: hidden;');
    iframe.setAttribute('frameborder', 0);
    iframe.setAttribute('border', 0);
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('allowTransparency', true);
    // accessibility attributes.
    // these prevent screenreaders from announcing
    // iframe contents or allowing navigation to these frames.
    iframe.setAttribute('tabindex', -1);
    iframe.setAttribute('hidden', true);
    iframe.setAttribute('title', '');
    iframe.setAttribute('role', 'presentation');

    // set the src to begin the loading process

    iframe.src = url;
    return iframe;
}


/**
 * Creates a success handler function
 * that clears the failure timeout
 * @returns Function<void>
 */
function _iframeCookieCheckLoaded(config, timer, name, start) {
    return function () {
        var elapsed = _nao() - start;
        config.cookieCheckLoaded = true;
        trk({
            status: 'IC_HERMES_COOKIE_CHECK_COMPLETE',
            elapsed: elapsed
        });
        clearTimeout(timer);
    };
}

/**
* Creates a function that will remove the iframe specified
* @returns Function<void>
*/
function _iframeTimedOut(iframe) {
    return function () {
        // stop loading of iframe content
        if (typeof (window.frames[iframe.name].stop) !== 'undefined') {
            window.frames[iframe.name].stop();
        } else {
            try {
                window.frames[iframe.name].document.execCommand('Stop');
            } catch (err) {
                // IE access denied error most likely,
                // can't stop won't stop so we let it be
            }

        }
        // remove listener for iframe load event
        // since we didn't make it in time
        iframe.onload = null;
        iframe.parentNode.removeChild(iframe);

    };
}

/**
 * Creates a success handler function
 * that clears the failure timeout
 * @returns Function<void>
 */
function _iframePrefetchLoaded(config, timer, name, start) {
    return function () {
        var elapsed = _nao() - start;
        config.prefetchLoaded = true;
        trk({
            status: 'IC_HERMES_PREFETCH_COMPLETE',
            elapsed: elapsed
        });
        clearTimeout(timer);
    };
}

/**
 * Prefetches resources before user clicks checkout button and
 * (hopefully) primes them in the browser's cache
 * @returns {undefined}
 */
function _setupPrefetchIframe(config) {
    var domain = getDomain(config);
    var url = domain + constants.PREFETCH_CONTEXT_ROOT + (config.debug ? '?resources_prefetch=1' : '');
    var iframe = _setupIframe(constants.PREFETCH_NAME, url);

    // set up timeout so slow prefetch/bridge loading
    // doesn't affect IC rendering
    var timer = setTimeout(_iframeTimedOut(iframe), constants.LOADING_TIMEOUT);
    var start = _nao();
    var iframeSuccess = _iframePrefetchLoaded(config, timer, name, start);
    listen(iframe, 'load', iframeSuccess);

    document.body.appendChild(iframe);
}

function _determineThirdPartyCookiesEnabled(config) {
    var domain = getDomain(config);
    var url = domain + constants.COOKIE_CHECK_PATH;
    var iframe = _setupIframe(constants.COOKIE_CHECK_NAME, url);

    // set up timeout so slow third-party cookie check loading doesn't affect IC rendering
    var timer = setTimeout(_iframeTimedOut(iframe), constants.LOADING_TIMEOUT);
    var start = _nao();
    var iframeSuccess = _iframeCookieCheckLoaded(config, timer, name, start);
    listen(iframe, 'load', iframeSuccess);

    document.body.appendChild(iframe);
}

/**
 * IE doesn't support cross domain post message. Create an iFrame Bridge to communicate between Mini browser and parent window.
 * This is only for IE
 * @returns {undefined}
 */
function _setUpPayPalBridge(config) {
    var domain = config.sandBox ? constants.SANDBOX_URL_ROOT : constants.LIVE_URL_ROOT;
    var bridgeUrl = config.bridgeUrl ? domain + config.bridgeUrl : domain + constants.BRIDGE_CONTEXT_ROOT;
    var iframe = _setupIframe(constants.BRIDGE_NAME, bridgeUrl);

    document.body.appendChild(iframe);
}

function IframeFactory(_track) {
    trk = _track;
    var iframe = {
        bridge: _setUpPayPalBridge,
        prefetch: _setupPrefetchIframe,
        thirdParty: _determineThirdPartyCookiesEnabled
    };
    return iframe;
}


module.exports = IframeFactory;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/iframes.js
 ** module id = 17
 ** module chunks = 0
 **/